// createCeiling.js
import { StandardMaterial, Color3 } from '@babylonjs/core';

/**
 * Clones a given floorMesh as a white plaster ceiling,
 * placing its bottom at maxYAmongAll in the scene,
 * with a mild emissive component so it appears white without direct light.
 */
export function createCeiling(scene, floorMesh, maxYAmongAll, assignBoxUVsRealWorld) {
  if (!floorMesh) return;

  // 1) Clone the floor
  const ceilingMesh = floorMesh.clone('ceilingMesh', null, true);

  // 2) Use a white plaster material with mild emissive
  const whitePlaster = new StandardMaterial('whitePlaster', scene);
  whitePlaster.diffuseColor = Color3.White();
  
  // -- Make it appear white even in low light
  whitePlaster.emissiveColor = new Color3(0.8, 0.8, 0.8);
  // If you want it purely self-lit, you can do 1,1,1
  // and/or set whitePlaster.disableLighting = true

  ceilingMesh.material = whitePlaster;

  // 3) Rotate 180 so the underside faces downward
  ceilingMesh.rotation.x = Math.PI;
  ceilingMesh.computeWorldMatrix(true);

  // 4) Position so that its bottom aligns with maxYAmongAll
  const cBB = ceilingMesh.getBoundingInfo().boundingBox;
  const cMinY = cBB.minimumWorld.y;
  const offsetY = maxYAmongAll - cMinY;
  ceilingMesh.position.z -= offsetY;

  // 5) Optional: Re-assign UVs if needed
  if (assignBoxUVsRealWorld) {
    assignBoxUVsRealWorld(ceilingMesh, 0.5);
  }
}
